import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=1181bf6c&scoped=true"
import script from "./uploadData.vue?vue&type=script&lang=js"
export * from "./uploadData.vue?vue&type=script&lang=js"
import style0 from "./uploadData.vue?vue&type=style&index=0&id=1181bf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181bf6c",
  null
  
)

export default component.exports